import axios from "axios"
import { BaseUrl, JsonConfig, jwtToken } from "./BaseRepository";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../Utils/Utils";
import fileDownload from "js-file-download";
import ExcelJS from 'exceljs';
import FileSaver from 'file-saver';
import { useState } from "react";


export const downloadUnmatchedXL = async () => {
    try {
        let url = `${BaseUrl}PReports_/Lookup_Data`;
        const data = [];
        const res = await axios.post(url, data, JsonConfig);
        if (res.data.statusCode === 200) {
            let sample = []
            sample = JSON.parse(res.data.payload)
            let loopedList = [];
            loopedList.push(['Full_Name', 'File_Number', "Client"])
            let i = 0;
            for (i = 0; i < sample.length; i++) {
                loopedList.push([
                    sample[i].Full_Name || '',
                    sample[i].File_Number || '',
                    sample[i].Client || ''
                ])
            }
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            for (i = 0; i < loopedList.length; i++) {
                worksheet.addRow(loopedList[i]);
            }
            workbook.xlsx.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    FileSaver.saveAs(blob, 'unmatchedData.xlsx');
                });
        }
        else if (res.data.statusCode === 204) {
            InfoMessage(res.data.message)
        }
        else {
            ErrorMessage("Unable to download");
        }
    }
    catch {
        ErrorMessage("Unable to download");
        return null;
    }
}

export const downloadMfXL = async () => {
    try {
        let url = `${BaseUrl}PReports_/Output_Data`;
        const data = [];
        const res = await axios.post(url, data, JsonConfig);

        if (res.data.statusCode === 200) {
            let sample = JSON.parse(res.data.payload);
            let loopedList = [];

            loopedList.push([
                'Client ID', 'Worker ID', 'Full Name', 'W State', 'Shift #', 'Client',
                'Hire Date', 'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#',
                'Regular', 'Overtime', 'Double Time', 'Lunch Hours', 'Holiday', 'Sick',
                'Vacation', 'Covid Sick Pay', 'Training Hours', 'Gym Allowance',
                'Maternity leave', 'Bonus'
            ]);

            loopedList.push([
                'Client ID', 'Worker ID', 'Full Name', 'W State', 'Shift #', 'Client',
                'Hire Date', 'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#',
                'Hours', 'Hours', 'Hours', 'Hours', 'Hours', 'Hours', 'Hours', 'Hours',
                'Hours', 'Amount', 'Hours', 'Amount'
            ]);

            for (let i = 0; i < sample.length; i++) {
                let hireDate = new Date(sample[i].Hire_date);
                let hireDateString = hireDate.toLocaleDateString('en-US');
                // let hireDateString = `${hireDate.getMonth() + 1}/${hireDate.getDate()}/${hireDate.getFullYear()}`;
                loopedList.push([
                    sample[i].Client_ID,
                    sample[i].Worker_ID,
                    sample[i].Full_Name,
                    sample[i].W_State,
                    sample[i].Shift,
                    sample[i].Client,
                    hireDateString,
                    sample[i].FLSA,
                    sample[i].Payrate,
                    sample[i].Comment,
                    sample[i].Rate_Override,
                    sample[i].Seq,
                    sample[i].RT_Hours,
                    sample[i].OT_Hours,
                    sample[i].DT_Hours,
                    sample[i].Lunch_Hours,
                    sample[i].Holiday_Hours,
                    sample[i].Sick_Hours,
                    sample[i].Vacation_Hours,
                    sample[i].CovidSickPay_Hours,
                    sample[i].Training_Hours,
                    sample[i].Gym_Allowance,
                    sample[i].Maternity_Hours,
                    sample[i].Bonous_Amount,
                ]);
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');

            for (let i = 0; i < loopedList.length; i++) {
                let row = worksheet.addRow(loopedList[i]);
                if (i > 1) { // Skip header rows
                    let cell = row.getCell(7);
                    let hireDate = new Date(cell.value);
                    if (!isNaN(hireDate)) {
                        cell.value = hireDate;
                        cell.numFmt = 'MM/dd/yyyy'; // Set cell value as Date with desired format
                    }
                }
                for (let colIndex of [11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 23]) { // Column indices for hours
                    let cell = row.getCell(colIndex);
                    if (typeof cell.value === 'number') {
                        cell.numFmt = '0.00'; // Two decimal places
                    }
                }
            }

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, 'PR Amgen Masterfile.xlsx');
        } else {
            ErrorMessage(res.data.message);
        }
    } catch (error) {
        ErrorMessage("Unable to download");
        return null;
    }
};

export const downloadBMSUnmatchedXL = async () => {
    try {
        let url = `${BaseUrl}PReports_/BMSLookupData`;
        const data = [];
        const res = await axios.post(url, data, JsonConfig);
        if (res.data.statusCode === 200) {
            let sample = []
            sample = JSON.parse(res.data.payload)
            let loopedList = [];
            loopedList.push(['Full_Name', 'File_Number', "Client"])
            let i = 0;
            for (i = 0; i < sample.length; i++) {
                loopedList.push([
                    sample[i].Full_Name || '',
                    sample[i].File_Number || '',
                    sample[i].Client || ''
                ])
            }
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            for (i = 0; i < loopedList.length; i++) {
                worksheet.addRow(loopedList[i]);
            }
            workbook.xlsx.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    FileSaver.saveAs(blob, 'BMSunmatchedData.xlsx');
                });
        }
        else if (res.data.statusCode === 204) {
            InfoMessage(res.data.message)
        }
        else {
            ErrorMessage("Unable to download");
        }
    }
    catch {
        ErrorMessage("Unable to download");
        return null;
    }
}

export const downloadBMSmasterFileXL = async () => {
    try {
        let url = `${BaseUrl}PReports_/PostingOutputData`;
        const data = [];
        const res = await axios.post(url, data, JsonConfig);
        if (res.data.statusCode === 200) {
            let sample = JSON.parse(res.data.payload);
            let loopedList = [];
            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W State', 'Shift #', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#',
                'Regular', 'Overtime', 'Double Time', "Lunch","Status"
            ]);

            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W State', 'Shift', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#',
                'Hours', 'Hours', 'Hours', "Hours","Status"
            ]);

            for (let i = 0; i < sample.length; i++) {
                const pr7thValue = sample[i].PR_7TH;
                loopedList.push([
                    sample[i].Client_ID,
                    sample[i].Worker_ID,
                    sample[i].Last_Name,
                    sample[i].First_Name,
                    sample[i].W_State,
                    sample[i].Shift,
                    sample[i].Client,
                    sample[i].FLSA,
                    sample[i].Payrate,
                    sample[i].Comment,
                    sample[i].Rate_Override,
                    sample[i].Seq,
                    sample[i].RT_Hours,
                    sample[i].OT_Hours,
                    sample[i].DT_Hours,
                    // sample[i].Holiday_Hours,
                    // sample[i].Sick_Hours,
                    // sample[i].Vacation_Hours,
                    sample[i].Lunch_Hours,
                    sample[i].Status
                ]);
                 // Use PR_7TH for conditional highlighting
                 sample[i].PR_7TH = pr7thValue;
            }

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            worksheet.addRows(loopedList);

            const headerRow = loopedList[0];
            const regularIndex = headerRow.indexOf('Regular');
            const OvertimeIndex = headerRow.indexOf('Overtime');
            const DoubleTimeIndex = headerRow.indexOf('Double Time');
            // const HolidayIndex = headerRow.indexOf('Holiday');
            // const SickIndex = headerRow.indexOf('Sick');
            // const VacationIndex = headerRow.indexOf('Vacation');
            const firstNameIndex = headerRow.indexOf('First Name');
            const lastNameIndex = headerRow.indexOf('Last Name');
            const hourColumnIndexes = [regularIndex, OvertimeIndex, DoubleTimeIndex];

            loopedList.slice(2).forEach((row, rowIndex) => {
                const excelRow = worksheet.getRow(rowIndex + 3);
                if (parseFloat(row[regularIndex]) > 40) {
                    excelRow.getCell(firstNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                    excelRow.getCell(lastNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                }
                // Highlight 'OT Hours' column if value > 0
                const pr7thValue = sample[rowIndex].PR_7TH;
                if (pr7thValue > 0) {
                    excelRow.eachCell({ includeEmpty: true }, (cell) => {
                        cell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: { argb: 'FFFFA07A' }, // Highlight color
                        };
                    });
                }

                // if (hourColumnIndexes.every(index => row[index] === "" || row[index] === null || row[index] === undefined)) {
                //     excelRow.getCell(firstNameIndex + 1).fill = {
                //         type: 'pattern',
                //         pattern: 'solid',
                //         fgColor: { argb: 'FFFF0000' }
                //     };
                //     excelRow.getCell(lastNameIndex + 1).fill = {
                //         type: 'pattern',
                //         pattern: 'solid',
                //         fgColor: { argb: 'FFFF0000' }
                //     };
                // }

                // Set hour columns as numbers
                hourColumnIndexes.forEach(colIndex => {
                    const value = parseFloat(row[colIndex]);
                    const cell = excelRow.getCell(colIndex + 1);
                    cell.value = isNaN(value) ? '' : value;
                    cell.numFmt = '0.00';
                });
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, 'PR_BMS Masterfile.xlsx');
        } else {
            ErrorMessage(res.data.message);
        }
    } catch (error) {
        ErrorMessage("Unable to download");
        return null;
    }
};

export const downloadAbbottUnmatchedXL = async (finalClient) => {
    try {
        let url = `${BaseUrl}PReports_/DynamicLookupData`;

        // Send finalClient inside an array as JSON body
        const data = [finalClient]; 
        console.log("Sending request with body:", data);

        const res = await axios.post(url, data, JsonConfig);

        if (res.data.statusCode === 200) {
            let sample = JSON.parse(res.data.payload);
            console.log("Received data:", sample);

            let loopedList = [["Full_Name", "File_Number", "Client"]];
            sample.forEach(item => {
                loopedList.push([
                    item.Full_Name || '',
                    item.File_Number || '',
                    item.Client || ''
                ]);
            });

            // Create Excel file
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Sheet1");
            loopedList.forEach(row => worksheet.addRow(row));

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            FileSaver.saveAs(blob, "AbbottunmatchedData.xlsx");
        } 
        else if (res.data.statusCode === 204) {
            InfoMessage(res.data.message);
        } 
        else {
            ErrorMessage("Unable to download");
        }
    } catch (error) {
        console.error("Error downloading:", error.response?.data || error);
        ErrorMessage("Unable to download");
    }
};



export const downloadAbbottmasterFileXL = async (finalClient,fromDate,toDate) => {
    try {
        
        const formattedfromDate = fromDate ? fromDate.format("MM-DD-YYYY") : null;
      const formattedtoDate = toDate ? toDate.format("MM-DD-YYYY") : null;
        let url;
         url = `${BaseUrl}PReports_/DynamicMasterFile`;
         const queryParams = [];
         if (formattedfromDate) queryParams.push(`fromdate=${formattedfromDate}`);
         if (formattedtoDate) queryParams.push(`todate=${formattedtoDate}`);
 
         // Add query parameters to URL if available
         if (queryParams.length > 0) {
           url += `?${queryParams.join("&")}`;
         }
        const data = [finalClient];
        const res = await axios.post(url, data, JsonConfig);
        if (res.data.statusCode === 200) {
            let sample = JSON.parse(res.data.payload);
            let loopedList = [];
            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W_State', 'Shift #', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#', 'Regular', 'Overtime',
                'Double Time', 'Lunch', 'Sick', 'Vacation', 'Holiday', 'Salary Amount','Status'
            ]);
            

            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W_State', 'Shift #', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#', 'Hours', 'Hours',
                'Hours', 'Hours', 'Hours', 'Hours', 'Hours', 'Salary Amount','Status'
            ]);

            for (let i = 0; i < sample.length; i++) {
                loopedList.push([
                    sample[i].Client_ID,
                    sample[i].Worker_ID,
                    sample[i].Last_Name,
                    sample[i].First_Name,
                    sample[i].W_State,
                    sample[i].Shift,
                    sample[i].Client,
                    sample[i].FLSA,
                    sample[i].Payrate,
                    sample[i].Comment,
                    sample[i].Rate_Override,
                    sample[i].Seq,
                    sample[i].RT_Hours,
                    sample[i].OT_Hours,
                    sample[i].DT_Hours,
                    sample[i].Lunch_Hours, // Ensure Lunch_Hours is mapped here
                    sample[i].Sick_Hours,
                    sample[i].Vacation_Hours,
                    sample[i].Holiday_Hours, // Map Holiday_Hours here
                    sample[i].Salary_Amount,
                    sample[i].status // Correctly map status here
                ]);
            }
            

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            worksheet.addRows(loopedList);

            const headerRow = loopedList[0];
            const regularIndex = headerRow.indexOf('Regular');
            const OvertimeIndex = headerRow.indexOf('Overtime');
            const DoubleTimeIndex = headerRow.indexOf('Double Time');
            const LunchIndex = headerRow.indexOf('Lunch');
            const SickIndex = headerRow.indexOf('Sick');
            const VacationIndex = headerRow.indexOf('Vacation');
            const HolidayIndex = headerRow.indexOf('Holiday');
            const FLSAIndex = headerRow.indexOf('FLSA');
            const firstNameIndex = headerRow.indexOf('First Name');
            const lastNameIndex = headerRow.indexOf('Last Name');
            const hourColumnIndexes = [regularIndex, OvertimeIndex, DoubleTimeIndex, LunchIndex, SickIndex, VacationIndex, HolidayIndex];

            loopedList.slice(2).forEach((row, rowIndex) => {
                const excelRow = worksheet.getRow(rowIndex + 3);
                if (row[FLSAIndex] == "Exempt" && parseFloat(row[regularIndex]) > 40) {
                    excelRow.getCell(firstNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                    excelRow.getCell(lastNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                }


                // Set hour columns as numbers
                hourColumnIndexes.forEach(colIndex => {
                    const value = parseFloat(row[colIndex]);
                    const cell = excelRow.getCell(colIndex + 1);
                    cell.value = isNaN(value) ? '' : value;
                    cell.numFmt = '0.00';
                });
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, 'PR_Abbott Masterfile.xlsx');
        } else {
            ErrorMessage(res.data.message);
        }
    } catch (error) {
        ErrorMessage("Unable to download");
        return null;
    }
};

export const downloadIntegraUnmatchedXL = async (client) => {
    try {
        let url = `${BaseUrl}PReports_/DynamicLookupData`;

        // Send client as an array in the request body
        const data = [client]; 
        console.log("Sending request with body:", data);

        const res = await axios.post(url, data, JsonConfig);

        if (res.data.statusCode === 200) {
            let sample = JSON.parse(res.data.payload) || [];
            console.log("Received data:", sample);

            let loopedList = [["Full_Name", "File_Number", "Client"]];
            sample.forEach(item => {
                loopedList.push([
                    item.Full_Name || '',
                    item.File_Number || '',
                    item.Client || ''
                ]);
            });

            // Create Excel file
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Sheet1");
            loopedList.forEach(row => worksheet.addRow(row));

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            FileSaver.saveAs(blob, "IntegraunmatchedData.xlsx");
        } 
        else if (res.data.statusCode === 204) {
            InfoMessage(res.data.message);
        } 
        else {
            ErrorMessage("Unable to download");
        }
    } catch (error) {
        console.error("Error downloading:", error.response?.data || error);
        ErrorMessage("Unable to download");
    }
};
export const downloadIntegramasterFileXL = async (client,fromDate, toDate) => {
    try {
        const formattedfromDate = fromDate ? fromDate.format("MM-DD-YYYY") : null;
        const formattedtoDate = toDate ? toDate.format("MM-DD-YYYY") : null;
          let url;
           url = `${BaseUrl}PReports_/DynamicMasterFile`;
           const queryParams = [];
           if (formattedfromDate) queryParams.push(`fromdate=${formattedfromDate}`);
           if (formattedtoDate) queryParams.push(`todate=${formattedtoDate}`);
   
           // Add query parameters to URL if available
           if (queryParams.length > 0) {
             url += `?${queryParams.join("&")}`;
           }
        const data = [client];
        const res = await axios.post(url, data, JsonConfig);
        // debugger
        if (res.data.statusCode === 200) {
            let sample = JSON.parse(res.data.payload);
            console.log(res.data.payload);
            let loopedList = [];
            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W_State', 'Shift #', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#', 'Regular', 'Overtime',
                'Double Time', 'Lunch', 'Sick', 'Vacation', 'Holiday', 'Salary Amount','Status'
            ]);

            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W_State', 'Shift #', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#', 'Hours', 'Hours',
                'Hours', 'Hours', 'Hours', 'Hours', 'Hours', 'Salary Amount','Status'
            ]);

            for (let i = 0; i < sample.length; i++) {
                loopedList.push([
                    sample[i].Client_ID,
                    sample[i].Worker_ID,
                    sample[i].Last_Name,
                    sample[i].First_Name,
                    sample[i].W_State,
                    sample[i].Shift,
                    sample[i].Client,
                    sample[i].FLSA,
                    sample[i].Payrate,
                    sample[i].Comment,
                    sample[i].Rate_Override,
                    sample[i].Seq,
                    sample[i].RT_Hours,
                    sample[i].OT_Hours,
                    sample[i].DT_Hours,
                    sample[i].Lunch_Hours, // Ensure Lunch_Hours is mapped here
                    sample[i].Sick_Hours,
                    sample[i].Vacation_Hours,
                    sample[i].Holiday_Hours, // Map Holiday_Hours here
                    sample[i].Salary_Amount,
                    sample[i].status // Correctly map status here
                ]);
            }
            

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            worksheet.addRows(loopedList);

            const headerRow = loopedList[0];
            const regularIndex = headerRow.indexOf('Regular');
            const OvertimeIndex = headerRow.indexOf('Overtime');
            const DoubleTimeIndex = headerRow.indexOf('Double Time');
            const LunchIndex = headerRow.indexOf('Lunch');
            const SickIndex = headerRow.indexOf('Sick');
            const VacationIndex = headerRow.indexOf('Vacation');
            const HolidayIndex = headerRow.indexOf('Holiday');
            const FLSAIndex = headerRow.indexOf('FLSA');
            const firstNameIndex = headerRow.indexOf('First Name');
            const lastNameIndex = headerRow.indexOf('Last Name');
            const hourColumnIndexes = [regularIndex, OvertimeIndex, DoubleTimeIndex, LunchIndex, SickIndex, VacationIndex, HolidayIndex];

            loopedList.slice(2).forEach((row, rowIndex) => {
                const excelRow = worksheet.getRow(rowIndex + 3);
                if (parseFloat(row[LunchIndex]) >= 0) {
                    excelRow.getCell(firstNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                    excelRow.getCell(lastNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                }

                // if (hourColumnIndexes.every(index => row[index] === "" || row[index] === null || row[index] === undefined)) {
                //     excelRow.getCell(firstNameIndex + 1).fill = {
                //         type: 'pattern',
                //         pattern: 'solid',
                //         fgColor: { argb: 'FFFF0000' }
                //     };
                //     excelRow.getCell(lastNameIndex + 1).fill = {
                //         type: 'pattern',
                //         pattern: 'solid',
                //         fgColor: { argb: 'FFFF0000' }
                //     };
                // }

                // Set hour columns as numbers
                hourColumnIndexes.forEach(colIndex => {
                    const value = parseFloat(row[colIndex]);
                    const cell = excelRow.getCell(colIndex + 1);
                    cell.value = isNaN(value) ? '' : value;
                    cell.numFmt = '0.00';
                });
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, 'PR_Integra Masterfile.xlsx');
        } else {
            ErrorMessage(res.data.message);
        }
    } catch (error) {
        ErrorMessage("Unable to download");
        return null;
    }
};
export const downloadHpeUnmatchedXL = async (client) => {
    try {
        let url = `${BaseUrl}PReports_/DynamicLookupData`;

        // Sending client as an array in the request body
        const data = [client];
        console.log("Sending request with body:", data);

        const res = await axios.post(url, data, JsonConfig);

        if (res.data.statusCode === 200) {
            const sample = JSON.parse(res.data.payload) || [];
            console.log("Received data:", sample);

            let loopedList = [["Full_Name", "File_Number", "Client"]];
            sample.forEach(item => {
                loopedList.push([
                    item.Full_Name || '',
                    item.File_Number || '',
                    item.Client || ''
                ]);
            });

            // Create and download Excel file
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Sheet1");
            loopedList.forEach(row => worksheet.addRow(row));

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            FileSaver.saveAs(blob, "HPEunmatchedData.xlsx");
        } 
        else if (res.data.statusCode === 204) {
            InfoMessage(res.data.message);
        } 
        else {
            ErrorMessage("Unable to download");
        }
    } catch (error) {
        console.error("Error downloading:", error.response?.data || error);
        ErrorMessage("Unable to download");
    }
};


export const downloadHpemasterFileXL = async (client,fromDate,toDate) => {
    try {
        const formattedfromDate = fromDate ? fromDate.format("MM-DD-YYYY") : null;
      const formattedtoDate = toDate ? toDate.format("MM-DD-YYYY") : null;
        let url;
         url = `${BaseUrl}PReports_/DynamicMasterFile`;
         const queryParams = [];
         if (formattedfromDate) queryParams.push(`fromdate=${formattedfromDate}`);
         if (formattedtoDate) queryParams.push(`todate=${formattedtoDate}`);
 
         // Add query parameters to URL if available
         if (queryParams.length > 0) {
           url += `?${queryParams.join("&")}`;
         }        const data = [client];
        const res = await axios.post(url, data, JsonConfig);
        // debugger
        if (res.data.statusCode === 200) {
            let sample = JSON.parse(res.data.payload);
            let loopedList = [];
            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W_State', 'Shift #', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#', 'Regular', 'Overtime',
                'Double Time', 'Lunch', 'Sick', 'Vacation', 'Holiday', 'Salary Amount','Status'
            ]);

            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W_State', 'Shift #', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#', 'Hours', 'Hours',
                'Hours', 'Hours', 'Hours', 'Hours', 'Hours', 'Salary Amount','Status'
            ]);

            for (let i = 0; i < sample.length; i++) {
                loopedList.push([
                    sample[i].Client_ID,
                    sample[i].Worker_ID,
                    sample[i].Last_Name,
                    sample[i].First_Name,
                    sample[i].W_State,
                    sample[i].Shift,
                    sample[i].Client,
                    sample[i].FLSA,
                    sample[i].Payrate,
                    sample[i].Comment,
                    sample[i].Rate_Override,
                    sample[i].Seq,
                    sample[i].RT_Hours,
                    sample[i].OT_Hours,
                    sample[i].DT_Hours,
                    sample[i].Lunch_Hours, // Ensure Lunch_Hours is mapped here
                    sample[i].Sick_Hours,
                    sample[i].Vacation_Hours,
                    sample[i].Holiday_Hours, // Map Holiday_Hours here
                    sample[i].Salary_Amount,
                    sample[i].status // Correctly map status here
                ]);
            }
            

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            worksheet.addRows(loopedList);

            const headerRow = loopedList[0];
            const regularIndex = headerRow.indexOf('Regular');
            const OvertimeIndex = headerRow.indexOf('Overtime');
            const DoubleTimeIndex = headerRow.indexOf('Double Time');
            const LunchIndex = headerRow.indexOf('Lunch');
            const SickIndex = headerRow.indexOf('Sick');
            const VacationIndex = headerRow.indexOf('Vacation');
            const HolidayIndex = headerRow.indexOf('Holiday');
            const FLSAIndex = headerRow.indexOf('FLSA');
            const firstNameIndex = headerRow.indexOf('First Name');
            const lastNameIndex = headerRow.indexOf('Last Name');
            const hourColumnIndexes = [regularIndex, OvertimeIndex, DoubleTimeIndex, LunchIndex, SickIndex, VacationIndex, HolidayIndex];

            loopedList.slice(2).forEach((row, rowIndex) => {
                const excelRow = worksheet.getRow(rowIndex + 3);
                if (parseFloat(row[LunchIndex]) > 0) {
                    excelRow.getCell(firstNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                    excelRow.getCell(lastNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                }

                // if (hourColumnIndexes.every(index => row[index] === "" || row[index] === null || row[index] === undefined)) {
                //     excelRow.getCell(firstNameIndex + 1).fill = {
                //         type: 'pattern',
                //         pattern: 'solid',
                //         fgColor: { argb: 'FFFF0000' }
                //     };
                //     excelRow.getCell(lastNameIndex + 1).fill = {
                //         type: 'pattern',
                //         pattern: 'solid',
                //         fgColor: { argb: 'FFFF0000' }
                //     };
                // }

                // Set hour columns as numbers
                hourColumnIndexes.forEach(colIndex => {
                    const value = parseFloat(row[colIndex]);
                    const cell = excelRow.getCell(colIndex + 1);
                    cell.value = isNaN(value) ? '' : value;
                    cell.numFmt = '0.00';
                });
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, 'PR_HPE Masterfile.xlsx');
        } else {
            ErrorMessage(res.data.message);
        }
    } catch (error) {
        ErrorMessage("Unable to download");
        return null;
    }
};

export const downloadLeoforceUnmatchedXL = async (client) => {
    try {
        // Sending client as an array in the request body (instead of query params)
        let url = `${BaseUrl}PReports_/DynamicLookupData`;

        const data = [client];
        console.log("Sending request with body:", data);

        const res = await axios.post(url, data, JsonConfig);

        if (res.data.statusCode === 200) {
            const sample = JSON.parse(res.data.payload) || [];
            console.log("Received data:", sample);

            let loopedList = [["Full_Name", "File_Number", "Client"]];
            sample.forEach(item => {
                loopedList.push([
                    item.Full_Name || '',
                    item.File_Number || '',
                    item.Client || ''
                ]);
            });

            // Create and download Excel file
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet("Sheet1");
            loopedList.forEach(row => worksheet.addRow(row));

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            FileSaver.saveAs(blob, "LeoforceUnmatchedData.xlsx");
        } 
        else if (res.data.statusCode === 204) {
            InfoMessage(res.data.message);
        } 
        else {
            ErrorMessage("Unable to download");
        }
    } catch (error) {
        console.error("Error downloading:", error.response?.data || error);
        ErrorMessage("Unable to download");
    }
};


export const downloadLeoforcemasterFileXL = async (client) => {
    try {
        let url = `${BaseUrl}PReports_/DynamicMasterFile`;
        const data = [client];
        const res = await axios.post(url, data, JsonConfig);
        // debugger
        if (res.data.statusCode === 200) {
            let sample = JSON.parse(res.data.payload);
            let loopedList = [];
            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W_State', 'Shift #', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#', 'Regular', 'Overtime',
                'Double Time', 'Lunch', 'Sick', 'Vacation', 'Holiday', 'Salary Amount','Salary'
            ]);

            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W_State', 'Shift #', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#', 'Hours', 'Hours',
                'Hours', 'Hours', 'Hours', 'Hours', 'Hours', 'Salary Amount','Salary'
            ]);

            for (let i = 0; i < sample.length; i++) {
                loopedList.push([
                    sample[i].Client_ID,
                    sample[i].Worker_ID,
                    sample[i].Last_Name,
                    sample[i].First_Name,
                    sample[i].W_State,
                    sample[i].Shift,
                    sample[i].Client,
                    sample[i].FLSA,
                    sample[i].Payrate,
                    sample[i].Comment,
                    sample[i].Rate_Override,
                    sample[i].Seq,
                    sample[i].RT_Hours,
                    sample[i].OT_Hours,
                    sample[i].DT_Hours,
                    sample[i].Lunch_Hours, // Ensure Lunch_Hours is mapped here
                    sample[i].Sick_Hours,
                    sample[i].Vacation_Hours,
                    sample[i].Holiday_Hours, // Map Holiday_Hours here
                    sample[i].Salary_Amount,
                    sample[i].status // Correctly map status here
                ]);
            }
            

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            worksheet.addRows(loopedList);

            const headerRow = loopedList[0];
            const regularIndex = headerRow.indexOf('Regular');
            const OvertimeIndex = headerRow.indexOf('Overtime');
            const DoubleTimeIndex = headerRow.indexOf('Double Time');
            const LunchIndex = headerRow.indexOf('Lunch');
            const SickIndex = headerRow.indexOf('Sick');
            const VacationIndex = headerRow.indexOf('Vacation');
            const HolidayIndex = headerRow.indexOf('Holiday');
            const FLSAIndex = headerRow.indexOf('FLSA');
            const firstNameIndex = headerRow.indexOf('First Name');
            const lastNameIndex = headerRow.indexOf('Last Name');
            const hourColumnIndexes = [regularIndex, OvertimeIndex, DoubleTimeIndex, LunchIndex, SickIndex, VacationIndex, HolidayIndex];

            loopedList.slice(2).forEach((row, rowIndex) => {
                const excelRow = worksheet.getRow(rowIndex + 3);
                if (parseFloat(row[LunchIndex]) >= 0) {
                    excelRow.getCell(firstNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                    excelRow.getCell(lastNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                }

                // if (hourColumnIndexes.every(index => row[index] === "" || row[index] === null || row[index] === undefined)) {
                //     excelRow.getCell(firstNameIndex + 1).fill = {
                //         type: 'pattern',
                //         pattern: 'solid',
                //         fgColor: { argb: 'FFFF0000' }
                //     };
                //     excelRow.getCell(lastNameIndex + 1).fill = {
                //         type: 'pattern',
                //         pattern: 'solid',
                //         fgColor: { argb: 'FFFF0000' }
                //     };
                // }

                // Set hour columns as numbers
                hourColumnIndexes.forEach(colIndex => {
                    const value = parseFloat(row[colIndex]);
                    const cell = excelRow.getCell(colIndex + 1);
                    cell.value = isNaN(value) ? '' : value;
                    cell.numFmt = '0.00';
                });
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, 'Leoforce Masterfile.xlsx');
        } else {
            ErrorMessage(res.data.message);
        }
    } catch (error) {
        ErrorMessage("Unable to download");
        return null;
    }
};
export const downloadAllUnmatchedXL = async (client) => {

    try {
        let url = `${BaseUrl}PReports_/DynamicLookupData`;
        const data = client;
        const res = await axios.post(url, data, JsonConfig);
        if (res.data.statusCode === 200) {
            let sample = []
            sample = JSON.parse(res.data.payload)
            let loopedList = [];
            loopedList.push(['Full_Name', 'File_Number', "Client"])
            let i = 0;
            for (i = 0; i < sample.length; i++) {
                loopedList.push([
                    sample[i].Full_Name,
                    sample[i].File_Number,
                    sample[i].Client
                ])
            }
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            for (i = 0; i < loopedList.length; i++) {
                worksheet.addRow(loopedList[i]);
            }
            workbook.xlsx.writeBuffer()
                .then(buffer => {
                    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                    FileSaver.saveAs(blob, 'UnmatchedListData.xlsx');
                });
        }
        else if (res.data.statusCode === 204) {
            InfoMessage(res.data.message)
        }
        else {
            ErrorMessage("Unable to download");
        }
    }
    catch {
        ErrorMessage("Unable to download");
        return null;
    }
}

export const downloadTotalEnergiesmasterFileXL = async (client) => {
    try {
        let url = `${BaseUrl}PReports_/DynamicMasterFile?Client=${client}`;
        const data = [];
        const res = await axios.post(url, data, JsonConfig);
        // debugger
        if (res.data.statusCode === 200) {
            let sample = JSON.parse(res.data.payload);
            let loopedList = [];
            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W_State', 'Shift #', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#', 'Regular', 'Overtime',
                'Double Time', 'Lunch', 'Sick', 'Vacation', 'Holiday', 'Salary Amount','Status'
            ]);

            loopedList.push([
                'Client ID', 'Worker ID', 'Last Name', 'First Name', 'W_State', 'Shift #', 'Client',
                'FLSA', 'Pay Rate', 'Comment', 'Rate Override', 'Seq#', 'Hours', 'Hours',
                'Hours', 'Hours', 'Hours', 'Hours', 'Hours', 'Salary Amount','Status'
            ]);

            for (let i = 0; i < sample.length; i++) {
                loopedList.push([
                    sample[i].Client_ID,
                    sample[i].Worker_ID,
                    sample[i].Last_Name,
                    sample[i].First_Name,
                    sample[i].W_State,
                    sample[i].Shift,
                    sample[i].Client,
                    sample[i].FLSA,
                    sample[i].Payrate,
                    sample[i].Comment,
                    sample[i].Rate_Override,
                    sample[i].Seq,
                    sample[i].RT_Hours,
                    sample[i].OT_Hours,
                    sample[i].DT_Hours,
                    sample[i].Lunch_Hours, // Ensure Lunch_Hours is mapped here
                    sample[i].Sick_Hours,
                    sample[i].Vacation_Hours,
                    sample[i].Holiday_Hours, // Map Holiday_Hours here
                    sample[i].Salary_Amount,
                    sample[i].status // Correctly map status here
                ]);
            }
            

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Sheet1');
            worksheet.addRows(loopedList);

            const headerRow = loopedList[0];
            const regularIndex = headerRow.indexOf('Regular');
            const OvertimeIndex = headerRow.indexOf('Overtime');
            const DoubleTimeIndex = headerRow.indexOf('Double Time');
            const LunchIndex = headerRow.indexOf('Lunch');
            const SickIndex = headerRow.indexOf('Sick');
            const VacationIndex = headerRow.indexOf('Vacation');
            const HolidayIndex = headerRow.indexOf('Holiday');
            const FLSAIndex = headerRow.indexOf('FLSA');
            const firstNameIndex = headerRow.indexOf('First Name');
            const lastNameIndex = headerRow.indexOf('Last Name');
            const hourColumnIndexes = [regularIndex, OvertimeIndex, DoubleTimeIndex, LunchIndex, SickIndex, VacationIndex, HolidayIndex];

            loopedList.slice(2).forEach((row, rowIndex) => {
                const excelRow = worksheet.getRow(rowIndex + 3);
                if (parseFloat(row[LunchIndex]) >= 0) {
                    excelRow.getCell(firstNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                    excelRow.getCell(lastNameIndex + 1).fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFF44F' }
                    };
                }

                // if (hourColumnIndexes.every(index => row[index] === "" || row[index] === null || row[index] === undefined)) {
                //     excelRow.getCell(firstNameIndex + 1).fill = {
                //         type: 'pattern',
                //         pattern: 'solid',
                //         fgColor: { argb: 'FFFF0000' }
                //     };
                //     excelRow.getCell(lastNameIndex + 1).fill = {
                //         type: 'pattern',
                //         pattern: 'solid',
                //         fgColor: { argb: 'FFFF0000' }
                //     };
                // }

                // Set hour columns as numbers
                hourColumnIndexes.forEach(colIndex => {
                    const value = parseFloat(row[colIndex]);
                    const cell = excelRow.getCell(colIndex + 1);
                    cell.value = isNaN(value) ? '' : value;
                    cell.numFmt = '0.00';
                });
            });

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(blob, 'Leo_TotalEnergies Masterfile.xlsx');
        } else {
            ErrorMessage(res.data.message);
        }
    } catch (error) {
        ErrorMessage("Unable to download");
        return null;
    }
};